import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  BookingSpecialistServicesQueryParams,
  BookingSpecialistServicesResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingSpecialistServiceKeys = {
  all: () => ['bookingSpecialistServices'] as const,
  list: (props: BookingSpecialistServicesQueryParams) =>
    [
      ...bookingSpecialistServiceKeys.all(),
      'list',
      props.url,
      props.locationId,
      props.staffId,
      props.bookingType,
    ] as const,
};

export const bookingSpecialistServiceQueries = {
  list: (props: BookingSpecialistServicesQueryParams) =>
    queryOptions({
      queryKey: bookingSpecialistServiceKeys.list(props),
      queryFn: () =>
        HttpClient.request<BookingSpecialistServicesResponse>({
          method: 'GET',
          url: props.url,
          params: {
            location_id: props.locationId,
            staff_id: props.staffId,
            booking_type: props.bookingType,
          },
        }),
      enabled: !!props.url && !!props.locationId && !!props.staffId,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    }),
};
